import { VersionData } from './version.types';

/**
 * Reads the version from app.json file
 * @returns Promise<string> The version string in format "major.minor.buildId"
 */
const getVersion = async (): Promise<string> => {
	try {
		const response = await fetch('/app.json');
		if (!response.ok) {
			throw new Error('Failed to fetch app.json');
		}
		const versionData: VersionData = await response.json();
		const { major, minor, buildId } = versionData;
		return `${major}.${minor}.${buildId}`;
	} catch (error) {
		console.error('Error reading version:', error);
		return 'unknown';
	}
};

/**
 * Writes the version to a meta tag in the DOM
 * @param version The version string to write
 */
const writeVersionToDom = (version: string): void => {
	const headerMetadataElement = document.querySelector("meta[name='appVersionNumber']");
	if (headerMetadataElement) {
		headerMetadataElement.setAttribute('content', version);
	}
};

export { getVersion, writeVersionToDom };
